(function () {
    $(function () {
        function submitter ($root) {
            const $input = $root.find('.ui-submitter__input')
            const $submit = $root.find('.ui-submitter__submit')
            const $cancel = $root.find('.ui-submitter__cancel')
            const minLen = parseInt($root.data('minLen') || 1)
            
            function updateState() {
                if ($root.hasClass('ui-submitter_submitted') || $input.val().length < minLen) {
                    disableButton()
                } else {
                    enableButton()
                }
            }
            
            function input() {
                if ($root.hasClass('ui-submitter_submitted')) {
                    $root.removeClass('ui-submitter_submitted')
                    cancel()
                }
                updateState()
            }
            function submit() {
                if ($input.val().length >= minLen && $submit.is(':not(:disabled)')) {
                    $root.trigger('submitterSubmit', [$input.val()])
                    updateState()
                } else {
                    $input.focus()
                }
            }
            function cancel() {
                const cancelledVal = $input.val()
                $root.trigger('submitterCancel', [cancelledVal])
            }
            function clean() {
                cancel()
                $root.removeClass('ui-submitter_submitted')
                // todo 
                $input.val('')
                updateState()
            }
            function setSubmitted() {
                $root.addClass('ui-submitter_submitted')
                updateState()
            }

            function disableButton() {
                $submit.prop('disabled', true)
            }

            function enableButton() {
                $submit.prop('disabled', false)
            }

            function disableInput() {
                $input.prop('disabled', true)
            }

            function enableInput() {
                $input.prop('disabled', false)
            }
            
            function disableAll() {
                disableInput()
                disableButton()
            }
            
            function enableAll() {
                enableInput()
                enableButton()
            }
            
            $root.on('submitterDoClean', clean)
            $root.on('submitterDoSetSubmitted', setSubmitted)
            // $root.on('submitterDoSetDefault', setDefault)
            $root.on('submitterDoDisable', disableAll)
            $root.on('submitterDoEnable', enableAll)
            $root.on('submitterDoUpdateState', updateState)
            
            $submit.on('click', event => {
                event.preventDefault()
                if (!$submit.prop('disabled'))
                    submit()
            })
            $input.on({
                input: input,
                keyup: event => {
                    if (event.key === 'Enter' || event.keyCode === 13) {
                        submit()
                    }
                }
            })
            
            if ($cancel.length > 0) {
                $cancel.on('click', event => {
                    event.preventDefault()
                    if (!$cancel.prop('disabled')) {
                        clean()
                    }
                })
            }
    
            // init
            updateState()
        }
        
        $(document).on('submitterInit', '.ui-submitter', event => {
            submitter($(event.target))
        })
        
        $('.ui-submitter').each((index, element) => {
            submitter($(element))
        })
    })
}());
